import {
  Green500,
  Orange500,
  Purple500,
  Red500,
  TrelloBlue500,
  Yellow500,
} from '@trello/colors';

export const cardCoverColors = {
  blue: TrelloBlue500,
  green: Green500,
  orange: Orange500,
  purple: Purple500,
  red: Red500,
  yellow: Yellow500,
};
